import React, { useId } from 'react';
import { OptionRequest } from '../../../../api/assignments/dto/QuestionRequests.dto';
import styles from './assignment.module.css';

export interface OptionsEditorProps {
  type: 'single_choice' | 'multiple_choice';
  options: OptionRequest[];
  onChange: (_opts: OptionRequest[]) => void;
  disabled?: boolean;
}

// Редактор вариантов ответа для вопросов с выбором (single_choice / multiple_choice).
// Для single_choice верный вариант выбирается radio-группой (снимает отметку с остальных),
// для multiple_choice — независимыми чекбоксами.
export const OptionsEditor: React.FC<OptionsEditorProps> = ({
  type,
  options,
  onChange,
  disabled = false,
}) => {
  const groupName = useId();

  const handleTextChange = (index: number, value: string) => {
    onChange(options.map((option, i) => (i === index ? { ...option, option_text: value } : option)));
  };

  const handleCorrectChange = (index: number) => {
    if (type === 'single_choice') {
      onChange(options.map((option, i) => ({ ...option, is_correct: i === index })));
      return;
    }

    onChange(
      options.map((option, i) => (i === index ? { ...option, is_correct: !option.is_correct } : option)),
    );
  };

  const handleRemove = (index: number) => {
    onChange(options.filter((_option, i) => i !== index));
  };

  const handleAdd = () => {
    onChange([...options, { option_text: '', is_correct: false }]);
  };

  return (
    <div className={styles.options}>
      {options.map((option, index) => (
        <div key={index} className={styles.optionRow}>
          <input
            className={styles.optionMark}
            type={type === 'single_choice' ? 'radio' : 'checkbox'}
            name={groupName}
            aria-label="Верный вариант"
            checked={option.is_correct}
            onChange={() => handleCorrectChange(index)}
            disabled={disabled}
          />
          <input
            className={styles.optionInput}
            type="text"
            aria-label="Текст варианта"
            value={option.option_text}
            onChange={(e) => handleTextChange(index, e.target.value)}
            disabled={disabled}
          />
          <button
            className={styles.optionRemove}
            type="button"
            aria-label="Удалить вариант"
            onClick={() => handleRemove(index)}
            disabled={disabled}
          >
            ✕
          </button>
        </div>
      ))}
      <button className={styles.addOption} type="button" onClick={handleAdd} disabled={disabled}>
        Добавить вариант
      </button>
    </div>
  );
};

export default OptionsEditor;
